<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-wrench
      </v-icon>
      Support Tickets
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <delete-issue
        v-if="showDelete"
        :title="'Delete this ticket ?'"
        @closed="showDelete = false"
        @confirmed="deleteConfirmed()"
      />
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="showForm = true"
        >
          Report Issue
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="finalIssueList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.type }}</td>
            <td>
              <p v-if="item.client_reference !== null">
                {{ item.client_reference }}
              </p>
              <p v-else>
                NA
              </p>
            </td>
            <td>
              <p v-if="item.digi_board_id !== null">
                {{ item.digi_board_id }}
              </p>
              <p v-else>
                NA
              </p>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.created_at | convertToLocal }}</td>
            <td>
              <p>
                <font
                  :color="getColor(item.status)"
                  class="font-my-style"
                >
                  {{ item.status | statusUpdate }}
                </font>
              </p>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="editTicket(item.id)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="red"
                @click="deleteIssue(item.id)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <support-form
          v-model="showForm"
          @get-latest-tickets="showTickets"
        />
      </div>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import moment from 'moment';
  import SupportForm from './supportForm.vue';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'Support',
    components: {
      SupportForm,
      'delete-issue': DeleteDialog,
      'centre-spinner': spinner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'open') {
          return 'Open*';
        } else if (status === 'inProgress') {
          return 'Working';
        } else if (status === 'parked') {
          return 'Parked';
        } else {
          return 'Done';
        }
      },
    },
    data () {
      return {
        search: '',
        showForm: false,
        showDelete: false,
        deleteId: '',
        headers: [
          { text: 'Ticket Name', align: 'start', value: 'name' },
          { text: 'Type', value: 'type' },
          { text: 'Reference No.', value: 'client_reference' },
          { text: 'Digi-Board Id', value: 'digi_board_id' },
          { text: 'Description', value: 'description' },
          { text: 'Reported At', value: 'created_at' },
          { text: 'Status', value: 'status' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        loading: false,
      };
    },
    computed: {
      finalIssueList () {
        return this.$store.getters['support/getFinalIssueList'];
      },
    },
    mounted () {
      this.showTickets();
      this.$store.dispatch('support/clearTicketContent');
    },
    methods: {
      async showTickets () {
        this.loading = true;
        await this.$store.dispatch('support/fetchSupportTickets', {
          params: {
            orderBy: 'created_at',
          },
        });
        this.loading = false;
      },
      deleteIssue (ticketId) {
        this.showDelete = true;
        this.deleteId = ticketId;
      },
      deleteConfirmed () {
        this.$store.dispatch('support/deleteIssueTicket', this.deleteId).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Ticket deleted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.showTickets();
        }).finally(
          this.showDelete = false,
        );
      },
      getColor (status) {
        if (status === 'open') {
          return '#2E7D32';
        } else if (status === 'inProgress') {
          return '#E65100';
        } else if (status === 'parked') {
          return '#C62828';
        } else {
          return '#263238';
        }
      },
      editTicket (ticketId) {
        this.$router.push(`/support/${ticketId}`);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.font-my-style {
  font-weight: bold;
}
</style>
